// removed by extract-text-webpack-plugin
module.exports = {"body":"Body-style__body__utg_x"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/global/views/modal/Body-style.scss
// module id = 3048
// module chunks = 62